<i18n>
{
	"en": {
		"documents": "Documents",
		"noDocuments": "There are no documents yet.",
		"open": "Open",
		"documentType": "Type",
		"description": "Description",
		"alternateDescription": "Alternate Description"
	},
	"no": {
		"documents": "Dokumenter",
		"noDocuments": "Det er ingen dokumenter ennå.",
		"open": "Åpne",
		"documentType": "Type",
		"description": "Beskrivelse",
		"alternateDescription": "Alternativ Beskrivelse"
	}
}
</i18n>
<template>
	<div class="documents">
		<div class="documents-header">
			<t-panel-header
				:text="$t('documents')"
				icon="document"
				type="bp"
				size="md"
			/>
		</div>

		<t-grid
			v-if="documents && documents.length"
			ref="grid"
			:columnDefinitions="columnDefinitions"
			:rowHeight="50"
			:items="documents"
			:showFilters="false"
			class="documents-content"
			@selected="onRowsSelected"
		>
			<template #url="{ value }">
				<t-icon-button
					icon="document-open"
					type="bp"
					appearance="minimal"
					intent="primary"
					@click="openDocument(value)"
				/>
			</template>
		</t-grid>

		<t-no-content-panel
			v-else
			class="documents-content"
			:text="$t('noDocuments')"
			icon="document"
			iconType="bp"
			noBetweenGap
		/>
	</div>
</template>

<script>
export default {
	name: 'Documents',
	props: {
		order: Object,
	},
	computed: {
		columnDefinitions() {
			return [
				{
					field: 'url',
					displayName: this.$t('open'),
					width: 60,
					resizable: false,
				},
				{
					field: 'documentType',
					displayName: this.$t('documentType'),
					width: 50,
					resizable: false,
				},
				{
					field: 'description',
					displayName: this.$t('description'),
					minWidth: 100,
					resizable: true,
				},
				{
					field: 'alternateDescription',
					displayName: this.$t('alternateDescription'),
					minWidth: 100,
					resizable: true,
				},
				
			];
		},
		documents() {
			return this.order.documents || [];
		}
	},
	methods: {
		openDocument(url) {
			window.open(url);
		}
	}
};
</script>

<style lang="scss" scoped>
.documents {
	height: 100%;
	min-height: inherit;
}

.documents-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 15px;
	background: white;
}

.documents-content {
	height: 100%;
	width: 100%;
	min-height: inherit;
}
</style>

